import { useEffect } from 'react';
import { create } from 'zustand';

interface FilterState {
  resetCounter: number;
  bumpReset: () => void;
}

export const useFilterReset = create<FilterState>((set) => ({
  resetCounter: 0,
  bumpReset: () => set((s) => ({ resetCounter: s.resetCounter + 1 })),
}));

// Register a reset callback — fires when the global Reset button is clicked.
// Pass a function that clears this page's local filter state. Skips the first
// mount so existing state is preserved on page load.
export function useResetSub(clear: () => void) {
  const counter = useFilterReset((s) => s.resetCounter);
  useEffect(() => {
    if (counter === 0) return;
    clear();
  }, [counter]);
}
